// Configuración para exportación CSV
// España y otros países europeos usan punto y coma (;) como separador

/**
 * Separador CSV según configuración regional
 * España, Francia, Alemania, Italia, etc. usan ";"
 * EE.UU., Reino Unido usan ","
 */
export const CSV_SEPARATOR = ';';

/**
 * BOM (Byte Order Mark) para UTF-8
 * Necesario para que Excel y otras aplicaciones reconozcan correctamente los caracteres especiales
 */
export const CSV_BOM = '\uFEFF';
